import { motion } from "framer-motion";
import { CalendarDays, ArrowRight, Eye, Users, Clock } from "lucide-react";
import { HERO, ICLOSED_URL } from "../data/content";
import HeroVideos from "./HeroVideos";

const container = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.08, delayChildren: 0.1 } },
};
const item = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.75, ease: [0.16, 1, 0.3, 1] } },
};

const BULLETS = [
  { icon: Eye, label: "Plus de visibilité" },
  { icon: Users, label: "Plus de clients" },
  { icon: Clock, label: "En seulement 4h par mois" },
];

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="hero-glow relative overflow-hidden px-6 pb-16 pt-28 sm:pb-24 sm:pt-36 lg:pb-28 lg:pt-44"
    >
      <HeroVideos />
      <motion.div
        variants={container}
        initial="hidden"
        animate="visible"
        className="relative z-10 mx-auto flex max-w-4xl flex-col items-center text-center"
      >
        <motion.h1
          variants={item}
          className="font-head text-[1.9rem] font-extrabold uppercase leading-[1.08] tracking-[-0.03em] text-[#0B1220] sm:text-[3rem] sm:leading-[1.02] sm:tracking-[-0.02em] lg:text-[3.5rem] lg:leading-[1.02]"
        >
          <span className="block">Devenez la référence</span>
          <span className="block">de votre marché</span>
          <span className="block">grâce à <span className="text-[#2563EB]">30 contenus</span></span>
          <span className="block text-[#2563EB]">viraux qui convertissent.</span>
        </motion.h1>

        <motion.p variants={item} className="mt-4 max-w-sm text-[14px] font-medium leading-relaxed text-[#1F2937] sm:mt-6 sm:max-w-2xl sm:text-lg">
          {HERO.subtitle}
        </motion.p>

        <motion.div variants={item} className="mt-7 sm:mt-9">
          <a
            href={ICLOSED_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-cta"
            className="btn-blue group relative inline-flex items-center gap-2.5 overflow-hidden rounded-full px-6 py-3.5 text-sm font-semibold text-white sm:px-8 sm:py-4 sm:text-base"
          >
            <span
              aria-hidden="true"
              className="pointer-events-none absolute inset-0 -translate-x-[120%] skew-x-[-20deg] bg-white/25 blur-sm transition-transform duration-700 ease-out group-hover:translate-x-[220%]"
            />
            <CalendarDays size={19} className="relative transition-transform duration-300 group-hover:-rotate-12 group-hover:scale-110" />
            <span className="relative">{HERO.cta}</span>
            <ArrowRight size={18} className="relative w-0 -translate-x-2 opacity-0 transition-all duration-300 group-hover:w-[18px] group-hover:translate-x-0 group-hover:opacity-100" />
          </a>
        </motion.div>

        <motion.div
          variants={item}
          className="mt-7 flex flex-wrap items-center justify-center gap-2.5 sm:mt-10 sm:gap-x-4 sm:gap-y-3"
        >
          {BULLETS.map(({ icon: Icon, label }, i) => (
            <span
              key={i}
              className="flex items-center gap-1.5 rounded-full border border-[#E6EDF6] bg-white px-3 py-1.5 text-xs font-semibold text-[#0B1220] shadow-[0_4px_16px_-10px_rgba(15,23,42,0.3)] sm:gap-2 sm:px-4 sm:py-2 sm:text-sm"
            >
              <Icon size={14} className="text-[#2563EB]" />
              {label}
            </span>
          ))}
        </motion.div>
      </motion.div>
    </section>
  );
}
